// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { ehrBaseUrl } from '@/settings'

export const getPatientDiagnosis = async (mrn) => {
  try {
    const fetchParams = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + store.getters.jwt,
        'Content-Type': 'application/json',
      },

      body: JSON.stringify(mrn),
    }
    const url = `${ehrBaseUrl}/cancer_diagnosis`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result) {
      return []
    }

    // Translate the response to the format expected by the frontend.
    const diagnosisRespArray = Object.values(result)[0]
    const uniqueDiagnoses = [...new Set(diagnosisRespArray.map(JSON.stringify))].map(JSON.parse)
    return uniqueDiagnoses
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
